import Trustpilot from './Trustpilot';

export * from './Trustpilot';
export default Trustpilot;
